import { initFancybox } from "../../../../../../themes/growtype/resources/scripts/plugins/fancybox/initFancybox";
import { resolveGuestLocalRoleplayOpeningImage } from "../helpers/guestLocalHistory";

const SELECTOR = "[data-roleplay-opening-image-job]";
const MAX_OPENING_IMAGE_STATUS_POLLS = 120;
const MAX_OPENING_IMAGE_POLL_MS = 3 * 60 * 1000;
const OPENING_IMAGE_POLL_DELAY_MS = 1500;

function getAjaxConfig() {
  if (typeof growtype_chat_ajax !== "undefined") {
    return growtype_chat_ajax;
  }

  return window.growtype_chat_ajax || {};
}

function initializeResolvedImage(message) {
  message.find(".growtype-theme-fancybox").each(function (_index, element) {
    initFancybox(jQuery(element));
  });

  message.find("img[data-src]").each(function (_index, element) {
    const image = jQuery(element);
    image.attr("src", image.attr("data-src"));
  });
}

function loadingContent() {
  return (
    '<div class="growtype-chat-roleplay-opening-image-loader__visual" aria-hidden="true">' +
    '<span class="growtype-chat-roleplay-opening-image-loader__orb"></span>' +
    '<span class="growtype-chat-roleplay-opening-image-loader__icon"><i class="fa-regular fa-image"></i></span>' +
    '<span class="growtype-chat-roleplay-opening-image-loader__spark spark-one"></span>' +
    '<span class="growtype-chat-roleplay-opening-image-loader__spark spark-two"></span>' +
    '<span class="growtype-chat-roleplay-opening-image-loader__spark spark-three"></span>' +
    "</div>" +
    '<div class="growtype-chat-roleplay-opening-image-loader__copy">' +
    '<span class="growtype-chat-roleplay-opening-image-loader__eyebrow">Roleplay opening</span>' +
    '<span class="loader-text">Creating your opening scene...</span>' +
    '<span class="growtype-chat-roleplay-opening-image-loader__hint">Composing the setting, mood, and characters.</span>' +
    "</div>" +
    '<span class="growtype-chat-roleplay-opening-image-loader__progress" aria-hidden="true"></span>'
  );
}

function isMissingOpeningImageJob(message) {
  return (
    String(message || "")
      .trim()
      .toLowerCase() === "opening image job was not found."
  );
}

function hideLoaderMessage(loader) {
  loader.closest(".g-chatform-message").remove();
}

function failLoader(loader, message) {
  if (isMissingOpeningImageJob(message)) {
    hideLoaderMessage(loader);
    return;
  }

  const errorIcon = jQuery("<span>", {
    class: "growtype-chat-roleplay-opening-image-loader__error-icon",
    "aria-hidden": "true",
  }).append(jQuery("<i>", { class: "fa-solid fa-rotate-right" }));
  const errorCopy = jQuery("<div>", {
    class: "growtype-chat-roleplay-opening-image-loader__copy",
  }).append(
    jQuery("<span>", {
      class: "growtype-chat-roleplay-opening-image-loader__eyebrow",
      text: "Scene paused",
    }),
    jQuery("<span>", { class: "loader-text" }).text(
      message || "Could not create the opening scene."
    ),
    jQuery("<span>", {
      class: "growtype-chat-roleplay-opening-image-loader__hint",
      text: "Your conversation is safe. You can retry the image now.",
    })
  );
  const retryButton = jQuery("<button>", {
    type: "button",
    class: "btn btn-secondary btn-sm growtype-chat-roleplay-opening-image-loader__retry",
    "data-roleplay-opening-image-retry": "true",
    text: "Try again",
  });

  loader
    .removeClass("is-generating")
    .addClass("is-error")
    .empty()
    .append(errorIcon, errorCopy, retryButton);
}

function resetOpeningImagePollBudget(loader) {
  loader.removeAttr("data-roleplay-opening-image-poll-count");
  loader.removeAttr("data-roleplay-opening-image-poll-started-at");
}

function retryWhileGenerating(loader) {
  const now = Date.now();
  const startedAt = Number(
    loader.attr("data-roleplay-opening-image-poll-started-at") || now
  );
  const pollCount =
    Number(loader.attr("data-roleplay-opening-image-poll-count") || 0) + 1;

  loader.attr("data-roleplay-opening-image-poll-started-at", String(startedAt));
  loader.attr("data-roleplay-opening-image-poll-count", String(pollCount));

  if (
    pollCount > MAX_OPENING_IMAGE_STATUS_POLLS ||
    now - startedAt >= MAX_OPENING_IMAGE_POLL_MS
  ) {
    resetOpeningImagePollBudget(loader);
    failLoader(
      loader,
      "The opening scene is taking longer than expected. Please try again."
    );
    return;
  }

  window.setTimeout(() => {
    if (!loader[0]?.isConnected) {
      return;
    }

    loader.removeAttr("data-roleplay-opening-image-initialized");
    generateOpeningImage(loader);
  }, OPENING_IMAGE_POLL_DELAY_MS);
}

function generateOpeningImage(loader) {
  if (loader.attr("data-roleplay-opening-image-initialized") === "true") {
    return;
  }

  const ajaxConfig = getAjaxConfig();
  const action = ajaxConfig.roleplay_opening_image_action;
  const jobId = String(loader.attr("data-roleplay-opening-image-job") || "").trim();
  const messageId = String(loader.attr("data-message-id") || "").trim();
  const chatForm = loader.closest(".g-chatform");

  if (!action || !jobId || !chatForm.length) {
    return;
  }

  loader.attr("data-roleplay-opening-image-initialized", "true");

  jQuery.ajax({
    url: ajaxConfig.url,
    type: "post",
    data: {
      action,
      nonce: ajaxConfig.nonce,
      job_id: jobId,
      message_id: messageId,
      session_token: chatForm.attr("data-session-token") || "",
    },
    success(response) {
      if (!response?.success || !response?.data?.asset_html || !response?.data?.image_url) {
        failLoader(loader, response?.data?.message);
        return;
      }

      const message = loader.closest(".g-chatform-message");
      resetOpeningImagePollBudget(loader);
      loader.closest(".g-chatform-message-assets-wrapper").replaceWith(response.data.asset_html);
      initializeResolvedImage(message);
      resolveGuestLocalRoleplayOpeningImage(
        chatForm,
        jobId,
        response.data.image_url,
        message.prop("outerHTML") || ""
      );
    },
    error(xhr) {
      if (xhr?.status === 409) {
        retryWhileGenerating(loader);
        return;
      }

      failLoader(loader, xhr?.responseJSON?.data?.message);
    },
  });
}

function scan(root = document) {
  jQuery(root).find(SELECTOR).addBack(SELECTOR).each(function (_index, element) {
    generateOpeningImage(jQuery(element));
  });
}

export function initAsyncRoleplayOpeningImages() {
  scan(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          scan(node);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  jQuery(document).on("click", "[data-roleplay-opening-image-retry]", function () {
    const loader = jQuery(this).closest(SELECTOR);
    resetOpeningImagePollBudget(loader);
    loader
      .removeAttr("data-roleplay-opening-image-initialized")
      .removeClass("is-error")
      .addClass("is-generating")
      .html(loadingContent());
    generateOpeningImage(loader);
  });
}
